import { Skeleton } from '../../Skeleton'
import { EntityProfileHeaderEditableAvatar } from '../EntityProfileHeaderEditableAvatar'
import { EntityProfileHeaderStaticAvatar } from '../EntityProfileHeaderStaticAvatar'

import * as styles from './EntityProfileHeaderAvatar.module.css'

function EntityProfileHeaderAvatar({ editable, isLoading, ...restProps }) {
  return isLoading ? (
    <Skeleton className={styles.skeleton} />
  ) : editable ? (
    <EntityProfileHeaderEditableAvatar {...restProps} />
  ) : (
    <EntityProfileHeaderStaticAvatar {...restProps} />
  )
}

export default EntityProfileHeaderAvatar
